import { render, staticRenderFns } from "./InquiryOrderComparingChart.vue?vue&type=template&id=ffa6ba3c&"
import script from "./InquiryOrderComparingChart.vue?vue&type=script&lang=js&"
export * from "./InquiryOrderComparingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports